import * as React from 'react'

import { styled } from '~/styled'
import { cn } from '~/styled'

const Dot = styled('div', {
  base: [
    'animate-pulse',
    'bg-current',
    'rounded-full',
    'animation-duration-900',
    'nth-3:animation-delay-300',
    'nth-4:animation-delay-600'
  ],
  variants: {
    size: {
      sm: ['size-1', 'mx-0.5'],
      md: ['size-1.5', 'mx-0.5'],
      lg: ['size-2', 'mx-[3px]']
    }
  }
})

type LoaderProps = React.ComponentProps<'div'> & {
  message?: string
  size?: 'sm' | 'md' | 'lg'
}

export const Loader = ({
  className,
  message = 'Loading',
  size = 'md',
  ...props
}: LoaderProps) => (
  <div
    className={cn('flex', 'justify-center', className)}
    role="alert"
    {...props}
  >
    <span className="sr-only">{message}</span>
    <Dot size={size} />
    <Dot size={size} />
    <Dot size={size} />
  </div>
)
